import { HTMLAttributes, CSSProperties } from 'react';
import noop from '../../utils/noop';
import withTouchable from './withTouchable';

interface Props extends HTMLAttributes<HTMLDivElement> {
  highlightColor?: string;
}
const TouchableHighlight = withTouchable<Props>(props => {
  return {
    backgroundColor: props.highlightColor,
  } as CSSProperties;
}, 'touchable-highlight');

const styleEl = document.createElement('style');

styleEl.innerHTML = `.touchable-highlight{
transition: background-color .2s ease;
}`;

document.head.appendChild(styleEl);

TouchableHighlight.defaultProps = {
  onTouch: noop,
  onClick: noop,
  disabled: false,
  highlightColor: '#dedede',
};

export default TouchableHighlight;
